module.exports = __webpack_public_path__ + "static/media/pedido-realizado-orange.81c09f39.svg";